import { render } from "./Home.vue?vue&type=template&id=b3bb8132&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b3bb8132&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b3bb8132"

export default script